import request from './request'

export interface AdminProfile {
  id: number
  username: string
  nickname: string
  avatar: string
  role?: string
}

export interface UpdateProfileRequest {
  nickname?: string
  avatar?: string
}

export interface ProfileDetailResponse {
  code: number
  msg: string
  data: AdminProfile
}

export interface UpdateProfileResponse {
  code: number
  msg: string
  data: AdminProfile
}

export interface ChangePasswordResponse {
  code: number
  msg: string
}

/** POST `/api/admin/profile-detail` 获取当前管理员资料 */
export async function getAdminProfile(): Promise<ProfileDetailResponse> {
  return request.post<ProfileDetailResponse>('/api/admin/profile-detail', {})
}

/** POST `/api/admin/profile` 更新管理员资料 */
export const updateProfileApi = async (data: {
  nickname?: string
  avatarFile?: File
  avatarUrl?: string
}): Promise<UpdateProfileResponse> => {
  console.log('uploadProfileApi data=', data)
  const avatarValue = data.avatarUrl

  // 如果有文件需要上传，先上传获取URL
  // if (data.avatarFile) {
  //    console.log('开始上传')
  //   avatarValue = await uploadFile(data.avatarFile, {
  //     url: '/api/admin/upload',
  //     fieldName: 'file',
  //   })
  //   console.log('uploadFile avatarValue=', avatarValue)
  // }
  const requestBody: UpdateProfileRequest = {}
  if (data.nickname !== undefined) requestBody.nickname = data.nickname
  if (avatarValue !== undefined) requestBody.avatar = avatarValue

  console.log('requestBody=', requestBody)
  console.log('avatar type=', typeof requestBody.avatar)

  const response = await request.post<UpdateProfileResponse>('/api/admin/profile', requestBody, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

  return response
}

/** POST `/api/admin/change-password` 修改密码 */
export const changePasswordApi = async (data: {
  currentPassword: string
  newPassword: string
  confirmPassword: string
}): Promise<ChangePasswordResponse> => {
  const res = await request.post<ChangePasswordResponse>('/api/admin/change-password', {
    current_password: data.currentPassword,
    new_password: data.newPassword,
    confirm_password: data.confirmPassword,
  })
  return res
}
